<!-- Component that implements a list of documents -->
<template lang="html">
  <div>

  <c-confirm-dialog v-model="dialogConfirmaExclusao" @yes="excluirParceria()" titulo="Deseja realmente excluir a parceria?">
    A parceria "{{this.descricaoParceriaExclusao}}" será excluída após clicar na opção "Sim".
  </c-confirm-dialog>
    
    <v-layout wrap justify-space-between v-if="administrador === true || (projeto.funcao != null && projeto.funcao.item === 1) || projeto.assessor === true || usuarioPROEX === true">
      <v-flex xs12>
        <div class="instrucao">
          <v-card outlined>
            <v-card-text class="black--text font-weight-bold">
              Informar as parcerias/colaborações: contatos Nacionais e Internacionais efetivamente ocorridos em função da atividade, como convênios, acordos de colaboração, etc.
            </v-card-text>
          </v-card>
        </div>
      </v-flex>
    </v-layout>

    <v-data-table
    :headers="headers"
    :items="listaParcerias"
    :search="search"
    :no-data-text="'Este projeto não possui parcerias.'"
    must-sort
    :sort-by.sync="sortBy"
    :sort-desc.sync="sortDesc"
    :items-per-page="itemsPerPage"
    :footer-props="{itemsPerPageText: 'Linhas por página', itemsPerPageOptions: opcoesPaginacao}"
    >
      <template v-slot:item.descricao="props">
        <div v-if="administrador === true || (projeto.funcao != null && projeto.funcao.item === 1) || projeto.assessor === true">
          <router-link :to="{ name: 'EditarParceria', params: { idProjeto: idProjeto, idParceria: props.item.id }}">
            {{ props.item.nome }}
          </router-link>
        </div>
        <div v-else>
          {{ props.item.nome }}
        </div>
      </template>
      <template v-slot:item.opcoes="props">
        <v-btn v-if="administrador === true || (projeto.funcao != null && projeto.funcao.item === 1) || projeto.assessor === true" color="primary" text icon @click="botaoExcluirParceria(props.item.id, props.item.nome)" >
          <v-icon>delete</v-icon>
        </v-btn>
      </template>
      <template slot="footer.page-text" slot-scope="{ pageStart, pageStop }">
        Mostrando {{ pageStart }} a {{ pageStop }} de {{ listaParcerias.length }} parcerias
      </template>
    </v-data-table>
    <br><br>

    <c-card-footer
      :projeto="this.projeto"
      :extensao="this.extensao"
      proxima="AbrangenciaProjeto"
      editar="NovaParceria"
      nome_editar="Nova parceria"
      :habilitaBotaoGerarPDFAcao=true
      :habilitaBotaoFinalizarAcao=true
    >
    </c-card-footer>

  </div>
</template>

<script>
import ConfirmDialog from '@/components/c-confirm-dialog'
import CardFooter from '@/components/c-card-footer'
import BasicToolbar from '@/components/toolbars/basic-toolbar'
import dates from '@/utils/dates'
import projetos from '@/utils/projetos'
import { mapGetters, mapActions } from 'vuex'

export default {
  props: ['idProjeto', 'projeto', 'extensao'],
  data: () => ({
    dialogConfirmaExclusao: false,
    idParceriaExclusao: null,
    descricaoParceriaExclusao: '',
    listaParcerias: [],
    dates: dates,
    search: null,
    sortBy: 'funcao.descricao',
    sortDesc: false,
    itemsPerPage: 25,
    opcoesPaginacao: [ 10, 25, 50, {text: 'Todas', value: -1} ],
    headers: [
      { text: 'Nome do parceiro institucional/colaborador', align: 'left', value: 'descricao' },
      { text: 'Descrição da parceria/colaboração', align: 'left', value: 'detalhamento' },
      { text: 'Opções', align: 'left', value: 'opcoes' }
    ]
  }),
  computed: {
    ...mapGetters('auth', ['administrador', 'usuarioPROEX'])
  },
  methods: {
    ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),
    truncate (string, limit) {
      if (string.length > limit) return string.substring(0, limit) + '...'
      else return string
    },
    carregaParcerias: function (idProjeto) {
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando parcerias.' })
      projetos.getParceriasDoProjeto(this.idProjeto)
      .then(response => {
        this.listaParcerias = response.data.slice()
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando parcerias.' })
      })
    },
    botaoExcluirParceria: function (idParceria, descricao) {
      this.idParceriaExclusao = idParceria
      this.descricaoParceriaExclusao = descricao
      this.dialogConfirmaExclusao = true
    },
    excluirParceria: function () {
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Excluindo parceria.' })
      projetos.deleteParceria(this.idProjeto, this.idParceriaExclusao)
      .then(response => {
        this.SHOW_SNACKBAR({snackbarType: 'success', snackbarText: response.body.mensagem})
        this.carregaParcerias(this.idProjeto)
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
        this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Excluindo parceria.' })
      })
    }
  },
  mounted () {
    this.carregaParcerias(this.idProjeto)
  },
  components: {
    'basic-toolbar': BasicToolbar,
    'c-card-footer': CardFooter,
    'c-confirm-dialog': ConfirmDialog
  }
}
</script>

<style lang="css" slot-scoped>

.instrucao {
    text-align: center;
    margin-bottom: 2em;
  }

</style>



// WEBPACK FOOTER //
// projeto-parcerias-tabela.vue?ef55f276